export default __webpack_public_path__ + "static/media/model-y-mobile.c0a1a241.jpeg";